<template>
  <div class="centerPage">
    <div class="search flex">
      <span class="tit">用户管理</span>
      <div class="flex">
        <el-input placeholder="姓名" clearable v-model="search.fullName"></el-input>
        <el-select v-model="search.abode" placeholder="国家/地区/城市" @change="skipPage(1)" style="width: 128px">
          <el-option label="所有地区" value=""></el-option>
          <el-option :label="city" :value="city" v-for="city in cities" :key="city"></el-option>
          
        </el-select>
        <el-select v-model="search.appointStatus" placeholder="预约状态" @change="skipPage(1)">
          <el-option label="所有状态" value='0'></el-option>
          <el-option label="允许预约" value='1'></el-option>
          <el-option label="禁止预约" value='2'></el-option>
        </el-select>
        <el-button size="mini" @click="skipPage(1)">搜索</el-button>
      </div>
    </div>
    <div class="border">
      <el-table
          v-if="patients!=0"
          class="record-table"
          :data="patients"
          :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
          height="calc(100vh - 357px)">
        <!--<el-table-column label="序号" type="index" align="center" width="80" show-overflow-tooltip></el-table-column>-->
        <el-table-column prop="fullName" align="center" label="姓名" show-overflow-tooltip></el-table-column>
        <el-table-column label="性别" align="center" width="70">
          <template slot-scope="scope">
            {{ scope.row.gender == 0 ? '女' : scope.row.gender == 1 ? '男':'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="age" align="center" label="年龄" width="70"></el-table-column>
        <el-table-column prop="abodeCity" align="center" label="居住地" show-overflow-tooltip></el-table-column>
        <el-table-column label="状态" align="center" width="90">
          <template slot-scope="scope">
            <span :class="scope.row.appointStatus==1?'abled':'disabled'">{{ scope.row.appointStatus == 1 ? '可预约' : '不可预约' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="consultCount" label="咨询次数" width="90" align="center"></el-table-column>
        <el-table-column align="center" width="90">
          <template slot="header">
            <span>依从性</span>
            <el-popover placement="top-start" trigger="hover" content="记录为咨询最后一个的依从性数据">
              <i class="el-icon-question" slot="reference" style="font-size: 16px;margin-left: 2px"></i>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <span>{{scope.row.patientCompliance==1?'完全':scope.row.patientCompliance==2?'部分':'完全不'}}依从</span>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            width="260"
            align="center">
          <template slot-scope="scope">
            <el-popconfirm :title="scope.row.appointStatus==1?'确定要禁止预约吗？':'确定要允许预约吗？'"
                           @confirm="appointOp(scope.row)" style="margin-right: 10px">
              <el-button size="mini" :type="scope.row.appointStatus==0?'success':'danger'" slot="reference">{{ scope.row.appointStatus == 0 ? '允许预约' : '禁止预约' }}</el-button>
            </el-popconfirm>
            
            <el-button size="mini" class="orange-transparent" @click="toChat(scope.row.userId)" :loading="buttonLoading.chat">私信</el-button>
            <el-button size="mini" class="blue" @click="toDetail(scope.row.userId)">详情</el-button>
            
          </template>
        </el-table-column>
      </el-table>
      <div class="empty" v-else>
        <img src="../../assets/img/no.png" alt="" width="200">
        <p>这里什么都没有</p>
      </div>
      <el-pagination
          class="pagination"
          background
          prev-text="Prev"
          next-text="Next"
          @current-change="skipPage"
          :current-page="page.current"
          :page-size="page.size"
          layout="prev, pager, next"
          :total="page.total">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import base from '@/api/common';

export default {
  name: "patients",
  data() {
    return {
      patients: [],
      cities:[],
      search:{
        fullName: '',
        appointStatus: '0',
        abode: ''
      },
      page: {
        current: 1,
        size: 15,
        total: 0
      },
      doctorId: '',
  
      buttonLoading: {
        chat: false,
      },
    }
  },
  inject: ['reload'],
  methods: {
    toChat(userId) {
      if (userId) {
        this.buttonLoading.chat = true;
        this.$ajax.post(base.api.communication.chat.create.replace('{uid}', userId)).then(res => {
          this.buttonLoading.chat = false;
          if (res.data.status === 'success') {
            if (res.data.userType == 1) {
              this.$router.push({name: 'communicate', params: {id: res.data.id}});
            } else if (res.data.userType == 2) {
              this.$router.push({name: 'communicateDoc', params: {id: res.data.id}});
            } else {
              this.$message.error('error');
            }
          } else {
            this.$message.error(res.data.message);
          }
        }).catch(err => {
          console.error(err);
          this.$message.error('失败');
        })
      }
    },
    getData() {
      let vm = this;
      let params = {
        fullName: vm.search.fullName,
        appointStatus: Number(vm.search.appointStatus),
        abode: vm.search.abode
      };
      vm.$ajax.post(base.api.doctor.patients.replace('{pg}/{ps}', vm.page.current + '/' + vm.page.size),params)
          .then((res) => {
            if (res.data.status === 'success') {
              vm.patients = res.data.rows;
            }
          })
    },

    // 当前页
    skipPage(val) {
      this.page.current = val;
      this.getData();
    },
    appointOp(row) {
      let vm = this, appointStatus = 0;
      if (row.appointStatus == 1) {
        appointStatus = 0
      } else {
        appointStatus = 1;
      }
      let params = {
        id: row.dpid,
        appointStatus: appointStatus
      }
      vm.$ajax.post(base.api.doctor.patient.appointOp, params)
          .then((res) => {
            if (res.data.status == 'success') {
              vm.$message.success('保存成功');
            } else {
              vm.$message.error('保存失败');
            }
            vm.reload();
          })
    },
    toDetail(id) {
      this.$router.push({path: 'patient/' + id})
    }
  },
  async mounted() {
    let currentUser = await base.utils.getCurrent();
    if (currentUser) {
      this.doctorId = currentUser.id
    }
    this.getData();
    // 加载城市列表
    this.$ajax.get(base.basePath + 'auth/doctor-patients/authorize/groupCity').then(res=>{
        if(res.data.status === 'success'){
          this.cities = res.data.list;
        }
    })
  },
}
</script>

<style scoped lang="scss">
@import '../../assets/css/patients.scss';

.orange-transparent {
  background: transparent;
  border-color: #FF7C2F;
  color: #FF7C2F;
}
.orange {
  border-color: #FF7C2F;
  background-color: #FF7C2F;
  color: #FFFFFF;
}

</style>
